"use client";

import {
  getProductTileContainer,
  getProductTileClickImpressionContainerName,
  getContextToken,
  getProductTileImpressionContext,
  getProductTileScreenContainerContext,
  getProductTileScreenContext,
} from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/SDUIProductTileImpressionProvider";
import { ISDUIProductTileVariantRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/ProductTile/types";
import { PAGE_TYPE } from "@faire/deprecated-retailer-visitor-shared/consts/PAGE_TYPE";
import {
  getAltTag,
  getBrandAltTag,
} from "@faire/deprecated-retailer-visitor-shared/features/Marketplace/utils";
import { useGenerateProductLinkPropsFn } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductLink/SearchProductLink";
import {
  productClickForSearchPageParametersILeanProductTileAdapter,
  useOnProductClickForSearchPage,
} from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickForSearchPage";
import { ProductTile } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/index";
import { ProductTileType } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/types";
import { generateProductUrlForBrandPage } from "@faire/deprecated-retailer-visitor-shared/views/brand/utils/generateProductUrlForBrandPage";
import { useIsLoggedInRetailer } from "@faire/marketplace-lib/serialized-data/isLoggedInRetailer";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
import { useStrictLocalization } from "@faire/web/common/localization/localize";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import React from "react";

export const SDUIProductTileEvaluateRenderer = ({
  product,
  brand,
  loggingData,
}: ISDUIProductTileVariantRendererProps) => {
  useTraceComponentRender("ProductTileItem");
  const isLoggedInOrBrandPreview = useIsLoggedInRetailer();
  const { strictLocalize } = useStrictLocalization();
  const productTileContainer = getProductTileContainer(loggingData);
  const context = getProductTileImpressionContext(
    productTileContainer,
    loggingData
  );
  const containerName = getProductTileClickImpressionContainerName(loggingData);
  const requestId = loggingData.request_id;

  const screenContext = getProductTileScreenContext(loggingData);
  const containerContext = getProductTileScreenContainerContext(loggingData);
  const contextToken = getContextToken(loggingData);

  const productLinkPropsSearch = useGenerateProductLinkPropsFn({
    token: product.product?.token,
    brandToken: brand?.token,
    impressionId: product.product?.impression_id,
    selectedProductOptionToken: product.selected_product_option_token,
  });

  const productLinkPropsBrand = {
    productUrl: generateProductUrlForBrandPage(
      product.product?.token ?? "",
      product.selected_product_option_token,
      undefined
    ),
  };

  const { onProductClick } = useOnProductClickForSearchPage(
    productClickForSearchPageParametersILeanProductTileAdapter(product)
  );

  const altTag =
    loggingData.view_display_page === DisplayPageType.SEARCH_PAGE
      ? getAltTag(
          {
            productName: product.product?.name,
            pageType: PAGE_TYPE.DISCOVER,
            brandName: brand?.name,
          },
          strictLocalize
        )
      : getBrandAltTag(product.product?.name, brand?.name, strictLocalize);
  const productLinkProps =
    loggingData.view_display_page === DisplayPageType.SEARCH_PAGE
      ? productLinkPropsSearch
      : productLinkPropsBrand;

  return (
    <ProductTile
      product={product}
      loggingContext={{
        impressionProviderProps: {
          context,
          requestId,
          screenContext,
          containerContext,
          contextToken,
          trackedLinkContainerName: containerName,
        },
      }}
      tileInteractions={{
        props: {
          productLinkProps,
        },
        tileActions: {
          onProductClick:
            loggingData.view_display_page === DisplayPageType.SEARCH_PAGE
              ? onProductClick
              : undefined,
        },
      }}
      isLoggedIn={isLoggedInOrBrandPreview}
      type={ProductTileType.TILE_WITHOUT_BRAND}
      imageConfigProps={{
        altTag,
      }}
    />
  );
};
